'use strict';
import $ from 'jquery';
var _ = require('underscore');
var mediator = require('../../js/mediator');
var config = require('../../js/config');
var CarouselBaseView = require('./CarouselBaseView');
var utilities = require('../../js/utilities');
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';
import Analytics from '../../components/Analytics/Analytics.js';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';

var responsiveCarousal = false;
let ResponsiveCarouselView = CarouselBaseView.extend({
  prevMousePos: 'prev',
  options: {
    slideClass: '.ResponsiveCarousel-slide',
    pagination: false,
    paginationClass: 'ResponsiveCarousel-pagination',
    autoplay: false,
    infinite: false,
    accessibility: false,
    customPaging: function(slider, i) {
      var a = slider.$slides[i].getElementsByClassName('ImageAlign-container');
      var headingText = '';
      if (a && a.length === 1) {
        headingText = a[0].getAttribute('data-gtm-label').replace(/[\r\n]+/gm, '').trim();
      }
      if (EnableAdobeAnalytics.isEnabled() && !responsiveCarousal && utilities._isMobileOrTabletDevice()) {
        responsiveCarousal = true;
        let imageName = (slider.$slides[0].getElementsByClassName('ImageAlign-container').length > 0 ? slider.$slides[0].getElementsByClassName('ImageAlign-container')[0].dataset.gtmLabel.split('-')[1].trim() : undefined)
          || (slider.$slides[0].getElementsByClassName('InformationTile-link').length > 0 ? slider.$slides[0].getElementsByClassName('InformationTile-link')[0].dataset.gtmLabel.trim() : undefined);
        Analytics.adobeCarousalImageImp(imageName || undefined);
      }
      return '<button type="button" aria-label="' + headingText + '"></button>';
    },
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  },

  initialize: function(options) {
    var amount = this.$el.data('slide-amount'),
      self = this;

    if (this.$el.data('arrows') === true) {
      this.options.arrows = true;
      this.$el.on('mouseover', function(e) {
        self.initiateHover(e);
      });
      this.$el.on('mouseout', function() {
        self.removeButtonClass();
      });
    }

    this.options.slidesToShow = amount;
    this.options.slidesToScroll = amount;

    if (utilities._isMobileOrTabletDevice()) {
      options.autoplay = false;
      if (ResponsiveCarouselView.__super__.options) {
        ResponsiveCarouselView.__super__.options.autoplay = false;
      }
      if (this.options) {
        this.options.autoplay = false;
      }
    }

    this.options = _.defaults(this.options, ResponsiveCarouselView.__super__.options);

    ResponsiveCarouselView.__super__.initialize.call(this, options);
    ResponsiveCarouselView.__super__.modify = this.modify;

    mediator.on(config.events.breakpoint.desktop, self.backToFirst, self);

    if (this.el.slick) {
      const slick = this.el.slick;
      if (slick.$dots && slick.$dots.length) {
        slick.$dots.attr('role', 'tablist');
        slick.$dots.find('li').removeAttr('aria-hidden');

        var $buttonElms = slick.$dots.find('li button');
        $buttonElms.attr('role', 'tab');
        $buttonElms.attr('aria-current', false);
        $buttonElms.eq(slick.currentSlide).attr('aria-current', true);
        $buttonElms.each(function(index) {
          $(this).attr('aria-controls', 'tabpanel_' + (index + 1));
          $(this).attr('id', 'tab_' + (index + 1));
          $(this).on('focus', function() {
            slick.$dots.find('li').removeAttr('aria-hidden');
          });
          $(this).on('click', function() {
            slick.$dots.find('li').removeAttr('aria-hidden');
          });
          if (!index) {
            slick.$dots.attr('aria-owns', 'tab_' + (index + 1));
          } else {
            slick.$dots.attr('aria-owns', slick.$dots.attr('aria-owns') + ' ' + 'tab_' + (index + 1));
          }
        });
      }

      if (slick.$slides && slick.$slides.length) {
        slick.$slides.attr('role', 'tabpanel');

        slick.$slides.each(function(index) {
          $(this).attr('id', 'tabpanel_' + (index + 1));
          $(this).attr('aria-labelledby', 'tab_' + (index + 1));
        });
        this.modify(slick);
      }
      this.$('.slick-list').removeAttr('aria-live');
    }

    if (EnableAdobeAnalytics.isEnabled() && !utilities._isMobileOrTabletDevice()) {
      const slick = this.el.slick;
      if (slick && slick.$slides) {
        let responsiveCarousalList = [];
        let carousalName;
        slick.$slides.each(function() {
          let $slide = $(this);
          if ($slide.hasClass('slick-active')) {
            let imageAlignContainer = ($slide.find('.ImageAlign-container').length > 0 ? $slide.find('.ImageAlign-container')[0] : undefined) ||
              ($slide.find('.InformationTile-link').length > 0 ? $slide.find('.InformationTile-link')[0] : undefined);
            carousalName = imageAlignContainer ? (imageAlignContainer.dataset.gtmLabel.split('-')[1].trim() || imageAlignContainer.dataset.gtmLabel.trim()) : undefined;
            if (window.location.href.indexOf('/datasheets') > 0 || window.location.href.indexOf('/reference-designs') > 0) {
              carousalName = imageAlignContainer.dataset.gtmLabel.trim() || undefined;
            }
            if (carousalName) {
              responsiveCarousalList.push(carousalName);
            }
          }
        });
        if (responsiveCarousalList.length > 0) {
          Analytics.adobeCarousalMultipleImageImp(responsiveCarousalList);
        }
      }
    }
  },

  modify: function(slick) {
    slick.$slides.each(function() {
      const isInView = $(this).hasClass('slick-active') ? true : false;

      const tabIndex = isInView ? 0 : -1;
      const ariaHidden = isInView ? false : true;
      $(this).attr('aria-hidden', ariaHidden);

      var $ancharTags = $(this).find('a');
      $ancharTags.attr('aria-hidden', ariaHidden);
      $ancharTags.removeAttr('tabIndex');
      if (tabIndex === -1) {
        $ancharTags.attr('tabIndex', tabIndex);
      } else {
        $ancharTags.removeAttr('tabIndex');
      }

      var $imgTags = $(this).find('img');
      $imgTags.attr('aria-hidden', ariaHidden);
      if (tabIndex === -1) {
        $imgTags.attr('tabIndex', tabIndex);
      } else {
        $imgTags.removeAttr('tabIndex');
      }
    });
  },

  initialiseCarouselEvents: function() {
    ResponsiveCarouselView.__super__.initialiseCarouselEvents.call(this);

    // Add event listeners for slide changes
    this.$el.on('beforeChange', this.onBeforeChangeSlide);
    this.$el.on('afterChange', this.onAfterChangeSlide);
  },

  onBeforeChangeSlide: function(event, slick, currentSlide) {
    if (slick.$dots && slick.$dots.length) {
      slick.$dots.find('li button').eq(currentSlide).attr('aria-current',false);
    }
  },

  onAfterChangeSlide: function(event, slick, currentSlide) {
    if (slick.$dots && slick.$dots.length) {
      slick.$dots.find('li button').eq(currentSlide).attr('aria-current',true);
    }
    if (EnableAdobeAnalytics.isEnabled()) {
      let responsiveCarousalList = [];
      let carousalName;
      slick.$slides.each(function() {
        let $slide = $(this);
        if ($slide.hasClass('slick-active')) {
          let imageAlignContainer = ($slide.find('.ImageAlign-container').length > 0 ? $slide.find('.ImageAlign-container')[0] : undefined) ||
            ($slide.find('.InformationTile-link').length > 0 ? $slide.find('.InformationTile-link')[0] : undefined);
          carousalName = imageAlignContainer ? (imageAlignContainer.dataset.gtmLabel.split('-')[1].trim() || imageAlignContainer.dataset.gtmLabel.trim()) : undefined;
          if (window.location.href.indexOf('/datasheets') > 0 || window.location.href.indexOf('/reference-designs') > 0) {
            carousalName = imageAlignContainer.dataset.gtmLabel.trim() || undefined;
          }
          if (carousalName) {
            responsiveCarousalList.push(carousalName);
          }
        }
      });
      if (responsiveCarousalList.length > 0) {
        Analytics.adobeCarousalMultipleImageImp(responsiveCarousalList)
      }
    }
    ResponsiveCarouselView.__super__.modify(slick);
    mediator.trigger(config.events.carousel.slideChanged, this.$el);
  },

  initiateHover: function(e) {
    var x = e.pageX - this.$el.offset().left,
      half = this.$el.width() / 2,
      isLeft = x < half,
      className = '.slick-',

      txt = isLeft ? 'prev' : 'next';
    className += txt;

    if (this.prevMousePos !== txt) {
      this.$el.find('button').removeClass('is-active');
      this.prevMousePos = txt;
    }
    this.$(className).addClass('is-active');
  },

  removeButtonClass: function() {
    this.$('.slick-prev.is-active,.slick-next.is-active').removeClass('is-active');
  },

  backToFirst: function() {
    this.$el.slick('slickGoTo', 0);
  }

}, {
  create: function($parent) {
    parallelArrayEach($parent.find('.ResponsiveCarousel'), (el) => {
      new ResponsiveCarouselView({ el: el });
    });
  }
});

module.exports = ResponsiveCarouselView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/ResponsiveCarouselView.js